$(document).ready(function() {
  $('.slick-container').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true
  });

  $('.award-slider').closest('.container').css('background-color','#DCECF9');

  var jdgmCarouselWrapper = $('.template-index .jdgm-carousel-wrapper').parents('div').first();
  jdgmCarouselWrapper.addClass('container');
  jdgmCarouselWrapper.css('max-width','1460px'); //judgeme interface only allows intervals of 40px...

  var jdgmItemWrapperChildren = $('.template-index .jdgm-carousel-wrapper .jdgm-carousel__item-wrapper').children('.jdgm-carousel-item');
  jdgmItemWrapperChildren.each(function() {
    if ($(this).find('.jdgm-carousel-item__review-body').text().length > 300) {
      $(this).remove();
    }
  });
  $('.template-index .jdgm-carousel-wrapper').append('<a class="btn btn--small btn--primary btn-testomonial-carousel" href="/pages/reviews">See All Reviews</a>')

  $('.jdgm-carousel-title').addClass('large-title');

  $('.award-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: $('#awardPrev'),
    nextArrow: $('#awardNext'),
    responsive: [
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.testimonial-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: $('#testimonialPrev'),
    nextArrow: $('#testimonialNext'),
    responsive: [
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.press-testimonial-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: $('#testimonialPrev'),
    nextArrow: $('#testimonialNext'),
    responsive: [
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

});